import { memo } from "react";
import useSubscriptionInfo from "./hooks/useSubscriptionInfo.ts";
import DaysLeftBar from "./components/DaysLeftBar/index.tsx";
import StorageSpaceData from "./components/StorageSpaceData/index.tsx";
import Footer from "./components/Footer/index.tsx";
import { useUser } from "../../../../../contexts/userContext/userContext.js";

import styles from "./styles.module.scss";

/**
 * Renders the subscription information for the user.
 * This component displays the user's subscription details, storage usage, and expiration date.
 * It also provides options for renewing or upgrading the subscription.
 */
const SubscriptionInfo = memo(() => {
  const { getUserData } = useUser();
  const {
    sizeInUse,
    sizeMax,
    percentageOfSpace,
  } = useSubscriptionInfo();

  return (
    <div className={styles.userInfoWrapper}>
      <StorageSpaceData
        sizeInUse={sizeInUse}
        sizeMax={sizeMax}
        percentageOfSpace={+percentageOfSpace}
        sizeInUseInKb={getUserData().UserUsedStorage}
      />
      <Footer />
    </div>
  );
});

export default SubscriptionInfo;
